import React from "react";
import { lazyImport } from "@/lib/utils/lazyImports";
import { AuthenticationWrapper } from "@/components/AuthenticationWrapper";

const { AppRoutes } = lazyImport(() => import("@/routes/routes"), "AppRoutes");

function App() {
  return (
    <AuthenticationWrapper>
      <AppRoutes />
    </AuthenticationWrapper>
  );
}

export default App;
